export default __webpack_public_path__ + "static/media/arrow-left-solid.261fc5b9.svg";